import clipBoxByEditor from './clipBoxByEditor.vue';
export default clipBoxByEditor;
